'use strict'
import axios from '@/global/axios.js'
import * as action from '@/actions/domainRegistration'

// 域名注册-查询域名是否可注册
// export const CREATE_DOMAIN_CHECK = (domainName) => {
//   return axios({
//     url: action.CREATE_DOMAIN_CHECK,
//     method: 'POST',
//     data: { domainName }
//   })
// }
export const CREATE_DOMAIN_CHECK = (domainName) => {
  return axios({
    url: action.CREATE_DOMAIN_CHECK,
    method: 'POST',
    data: {domainName}
  })
}



// WEBPACK FOOTER //
// ./src/api/domainRegistration.js